import * as React from 'react';
import { useState, useEffect, useCallback } from 'react';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import highchartsMore from "highcharts/highcharts-more.js";
import Variablepie from 'highcharts/modules/variable-pie';
import { FxmsData } from "../../fxms/datas/FxData";

highchartsMore(Highcharts);
Variablepie(Highcharts);

export const FxIndcManagerChart = (props) => {
  const { title, allValues } = props;
  const [engPriceAmount, setEngPriceAmount] = useState({}); //월 에너지별 금액및 사용량
  const [totalPriceVal, setTotalPriceVal] = useState(0); //월 총 사용금액

  let engList = FxmsData.getDatas("energy");
  engList.sort((a, b) => a.engId.localeCompare(b.engId));

  let dataArr = null;
  dataArr = allValues;

  useEffect(() => {
    setEngPriceCalc();
  }, [dataArr])

  function setEngPriceCalc() {
    //에너지별 합산
    dataArr.push(
      { consUsageVal: 0, engId: 'EPWR' },
      { consUsageVal: 0, engId: 'AIR' },
      { consUsageVal: 0, engId: 'STEAM' }  
    );
    // dataArr.push({usageVal: 0,  engId: 'AIR'});
    // dataArr.push({usageVal: 0,  engId: 'STEAM'});
    // dataArr.push({usageVal: 0,  engId: 'COOLWATER'});

    const energyPriceMonth = dataArr.reduce((acc, cur) => {
      const { engId, consUsageVal, consUsageAmt } = cur;
      if (acc[engId]) {
        // acc[engId].usageVal += parseInt(usageVal) || 0; // 에너지 양
        // acc[engId].usageAmt += parseInt(usageAmt) || 0; // 총 사용비용
        acc[engId].consUsageVal += Math.abs(parseInt(consUsageVal)) || 0;
        acc[engId].consUsageAmt += Math.abs(parseInt(consUsageAmt)) || 0;

      } else {
        acc[engId] = { engId, consUsageVal: Math.abs(parseInt(consUsageVal)) || 0, consUsageAmt: Math.abs(parseInt(consUsageAmt)) || 0 };
      }
      return acc;
    }, { consUsageVal: 0, consUsageAmt: 0 });

    const energyPriceMonthVal = Object.values(energyPriceMonth).filter((elem) => typeof elem === 'object');

    // console.log("energyPriceMonthVal  >>", energyPriceMonthVal.filter(item => item.engid));
    setEngPriceAmount(energyPriceMonthVal)

    // const totalPrice = energyPriceMonthVal.map(item => item.usageAmt).reduce((prev, cur) => prev + cur, 0);
    const totalPrice = energyPriceMonthVal.map(item => Math.abs(parseInt(item.consUsageAmt))).reduce((prev, cur) => prev + cur, 0);
    setTotalPriceVal(totalPrice);

  }
  const getMonth = () => {
    let monthStr = '';
    if (dataArr.length > 0 && dataArr[0].yyyymm) {
      monthStr = dataArr[0].yyyymm;
      return monthStr.substr(4, 2);
    } else {
      return monthStr;
    }
  }

  const makeSeriesData = () => {
    const data = [];
    const values = engPriceAmount;
    const orderedEngNames = engList.map(obj => obj.engName);

    if (values) {
      for (const engName of orderedEngNames) {
        const value = Object.values(values).find(val => engList.find(obj => obj.engId === val.engId).engName === engName);
        if (value) {
          const temp = {};

          temp.name = engName;
          temp.y = value.consUsageAmt;
          temp.z = value.consUsageVal;

          data.push(temp);
        }
      }
    }
    
    return data;
  }
  const getSubtitle = () => {
    const totalNumber = totalPriceVal;
    return `
         <span style="color: rgb(255, 255, 255)">
            Total <br/> <strong>`+ Highcharts.numberFormat(totalNumber, 0, '.', ',') + `</strong> 원
         </span>`;
  }

  const getChartData4 = () => { // variablepie (circle)
    return {   
      title: {},      
      subtitle: {
        useHTML: true,
        text: getSubtitle(),
        floating: true,
        verticalAlign: 'middle',
        y: -10
      },
      chart: {
        type: 'pie',
        backgroundColor: "#313131",
        borderWidth: 1,
        borderRadius: 0,
        borderColor: "#303030",
        plotBackgroundColor: "#303030",
        plotBorderWidth: 1,
        plotBorderColor: "#303030",
        height: '80%',
        reflow: true,
        spacing: [0, 0, 0, 0], // 차트 여백 추가
      },
      tooltip: {
        headerFormat: '<b>' + getMonth() + '월</b> <br/><table>',
        pointFormatter: function () {
          var yValue = this.y;
          var units = {
            "압공": " Nm3",
            "냉수": " m3",
            "전력": " kW",
            "스팀": " kg"
          };
          var unit = units[this.name] || ''; // 해당 카테고리에 대한 단위가 없을 경우, 빈 문자열
          return '<span style="color:' + this.color + '"><b>● </b></span><span><b>' + this.name + '</b></span><br/>' +
            '<span style="padding:0"><b>에너지 사용량: ' + Highcharts.numberFormat(this.z, 0, '.', ',') + unit + '</b></span><br/>' +
            '<span style="padding:0"><b>에너지 사용금액: ' + Highcharts.numberFormat(yValue, 0, '.', ',') + ' 원</b></span>';
        },
      },
      legend: {
        enabled: false,
        itemStyle: {
          color: '#FFFFFF',
          fontWeight: 'thin',
          fontSize: '15px',
        },
        squareSymbol: true,
        layout: 'horizontal'
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: true,
            distance: 20, // 라벨을 바깥쪽으로 이동
            style: {
              fontSize: '12px',
              fontWeight: 'normal',
              color: '#ffffff'
            },
            formatter: function () {
              return this.key + '<br/>' + 
                     Highcharts.numberFormat(this.y, 0, '.', ',') + ' 원';
            },
            connectorWidth: 1, // 연결선 두께
            connectorColor: '#ffffff', // 연결선 색상
            connectorPadding: 5 // 연결선과 라벨 사이 간격
          },
          showInLegend: false,
          size: '50%', // 차트 크기를 더 작게 조정
          center: ['50%', '40%']
        }
      },
      series: [{
        innerSize: '60%',
        data: makeSeriesData()
      }]
    };
  }

  return (
    <>
      <div className="dualChart" >
        <HighchartsReact
          containerProps={{ style: { height: "100%" } }}
          highcharts={Highcharts}
          options={getChartData4()}
        />
      </div>
    </>

  );

}